// extracted by mini-css-extract-plugin
module.exports =  {"gig-attribute-wrapper":"FwL8nw3","gigAttributeWrapper":"FwL8nw3","gig-attribute":"TDCT8HJ","gigAttribute":"TDCT8HJ","attribute-text":"ts7LiSW","attributeText":"ts7LiSW"};